const features = [
  {
    id: 1,
    icon: 'ri-book-read-line',
    title: '下拉式阅读',
    desc: '独创下拉式漫画阅读模式，告别翻页，一气呵成，沉浸式追更体验。',
  },
  {
    id: 2,
    icon: 'ri-global-line',
    title: '海量免费全集',
    desc: '韩漫日漫国漫全覆盖，3000+部作品免费畅读，每日更新不重样。',
  },
  {
    id: 3,
    icon: 'ri-bell-line',
    title: '智能追更提醒',
    desc: '关注作品更新第一时间推送，不再错过每一话精彩内容。',
  },
];

export default function Features() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
            <i className="ri-star-smile-line text-primary-500 text-xl"></i>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">平台特色</h2>
        </div>
        <p className="text-foreground-500 text-sm md:text-base mb-8 ml-[52px]">为什么数百万读者选择羞羞漫画</p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="group p-8 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer hover:-translate-y-1 text-center"
            >
              <div className="w-16 h-16 rounded-2xl bg-primary-100 flex items-center justify-center mx-auto mb-5 group-hover:bg-primary-200 transition-colors">
                <i className={`${feature.icon} text-primary-500 text-2xl`}></i>
              </div>
              <h3 className="text-lg font-semibold text-foreground-800 mb-3">{feature.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}